import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import type { Group } from 'three';

/**
 * Thin wrapper around three's GLTFLoader.
 *
 * Phase 1 declares the interface but loads nothing. In Phase 2 the Blender
 * exports land in `public/assets/models/*.glb` and this becomes the only place
 * in the codebase that touches glTF, so swapping loaders or adding a DRACO
 * decoder later is a one-file change.
 */
export class ModelLoader {
  private readonly loader = new GLTFLoader();

  async load(url: string): Promise<Group> {
    const gltf = await this.loader.loadAsync(url);
    return gltf.scene;
  }
}
